import React, { Component } from 'react';
import { DataTable } from '../DataTable/DataTable';
import { convertUTCToLocalDateTime, getImgSrc, roundedOffPROMScore } from '../../helpers/GlobalFunctions'
import { PROMScoreTypes, scoreTypesForManualScore } from '../../containers/CaseDetails/constants';
import { operativeProcedureTypes } from '../../helpers/constants';
class ListProms extends Component {
	/**
	 * @description Function to decide whether to show the core name or subscore name
	 * @param score Each row instance
	 * @memberof ListProms
	 */
	/* istanbul ignore next  */
	checkScoreTypeLabel(score) {
		if (scoreTypesForManualScore.indexOf(score?.scoreType) > -1) {
			return score?.subScoreType ? score.subScoreType : score.scoreType;
		} else {
			return score.scoreType;
		}
	}

	/**
	 * @description Function to format score value
	 * @param score Each row instance
	 * @memberof ListProms
	 */
	formatScoreValue(score) {
		let scoreTypeObj = PROMScoreTypes[this.props.operativeProcedure?.toLowerCase()].find(x => x?.value === score?.scoreType)
		let scoreValue = roundedOffPROMScore(score?.score, score?.scoreType)
		return scoreTypeObj?.dataType === 'percentage' ? `${scoreValue}%` : scoreValue;
	}

	render() {
		const { caseId, refreshDataList, refreshOutcomeScore, operativeProcedure, surgeonUserName } = this.props;
		const isTSA = operativeProcedure?.toLowerCase() === operativeProcedureTypes.TSA.inLowerCase;
		/* istanbul ignore next  */
		const commonColumns = [
			{
				Header: 'Entry Date / Time',
				accessor: 'uploadedDate',
				Cell: ({ row }) => row.original.uploadedDate ? convertUTCToLocalDateTime(row.original.uploadedDate) : 'N/A',
				Filter: ''
			},
			{
				Header: 'Entry Type',
				accessor: 'source',
				Filter: ''
			},
			{
				Header: 'Score Type',
				accessor: 'scoreType',
				Cell: ({ row }) => row.original.scoreType ? isTSA ? row.original.scoreType : this.checkScoreTypeLabel(row.original) : 'N/A',
				Filter: ''
			},
			{
				Header: 'Time of Collection ',
				accessor: 'timeIntervals',
				Filter: '',
			},
			{
				Header: 'Score Value',
				accessor: 'score',
				Cell: ({ row }) => !isNaN(parseFloat(row.original.score)) && row.original.scoreType ? this.formatScoreValue(row.original) : '',
				Filter: '',
			},
			{
				Header: ' ',
				PromsAction: true
			}
		]
		/* istanbul ignore next  */
		const columns = [
			{
				// Make an expander cell
				Header: '',
				id: 'expander', // It needs an ID
				Cell: ({ row }) => (
					scoreTypesForManualScore.indexOf(row.original.scoreType) > -1 ?
						<span {...row.getToggleRowExpandedProps()}>
							{row.isExpanded ?
								<svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" fill="#73BC51" className="bi bi-eye-fill" viewBox="0 0 16 16">
									<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
									<path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
								</svg>
								: <svg width="1.6em" height="1.6em" viewBox="0 0 16 16" className="bi bi-eye-slash" xmlns="http://www.w3.org/2000/svg">
									<path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
									<path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
									<path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
									<path fillRule="evenodd" d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z" />
								</svg>}
						</span>
						: ''
				),
				// We can override the cell renderer with a SubCell to be used with an expanded row
				SubCell: () => null // No expander on an expanded row
			},
			...commonColumns
		]
		return (
			<div className="proms-blocks">
				<div className="proms-blocks-body proms-list-block">
					<div className="proms-block-title">PROM Score History</div>
					<div className="proms-table">
						{caseId ?
							<DataTable
								listType="proms-list" columns={isTSA ? columns : commonColumns}
								getId={caseId} showPagination={false}
								refreshDataList={refreshDataList}
								refreshOutcomeScore={refreshOutcomeScore}
								disableColmSort={true}
								operativeProcedure={operativeProcedure}
								surgeonUserName={surgeonUserName}
							/>
							: <div className="loading-img loading-img-center"><img className="" src={getImgSrc('loading.gif')} alt="loading" /> </div>}
					</div>
				</div>
			</div>
		);
	}
}
export default ListProms;
